import * as React from "react";

import { services } from "../../../../services";

import { useBackgroundPromiseEffectByCondition } from "../../../../helpers/hooks/useBackgroundPromiseEffectByCondition";
import { DocumentEditorComponent, DocumentEditorRef } from "../../../../components/actDocumentEditor";
import { useBackgroundPromiseWrapper } from "../../../../helpers/hooks/useBackgroundPromiseWrapper";
import { useDownload } from "../../../../helpers/hooks/useDownload";
import { NewButton } from "../../../../components/synced/ui/NewButton/NewButton";

import { Act } from "../../models/Act";
import { DataStorage } from "../../../../helpers/utils/DataStorage";
import { WorkflowInstance } from "../../../workflows/models/WorkflowInstance";
import { ActWorkflowInstanceModel } from "../../services/ProjectDocFolderService";
import { constantFormat } from "../../../../helpers/constants";

interface ActPrevIterationProps {
  docFolderId: number;
  dataStorage: DataStorage;
}

export const ActPrevIteration: React.FC<ActPrevIterationProps> = ({ docFolderId })  => {

  const [act, setAct] = React.useState<Act>();
  const [workflowInstance, setWorkflowInstance] = React.useState<WorkflowInstance>();
  const [actFolderId, setActFolderId] = React.useState<number>();

  const [promiseWrap, isLoading] = useBackgroundPromiseWrapper();
  const { downloadFile, isDownloading } = useDownload();
  const editorRef = React.useRef<DocumentEditorRef>(null);

  useBackgroundPromiseEffectByCondition(
    () => docFolderId > 0 && actFolderId !== docFolderId,
    () => services.projectDocFolderService.getActPrevIteration(docFolderId),
    (res: ActWorkflowInstanceModel) => {
      if (res) {
        let act = res.Act;
        if (act){
          if (act?.Created && typeof (act.Created) === "string")
            act.Created = new Date(act.Created);
        }
        setAct(act);

        let wi = res.WorkflowInstance;
        if (wi){
          if (wi?.Created && typeof (wi.Created) === "string")
            wi.Created = new Date(wi.Created);
        }
        setWorkflowInstance(wi);
      }
      setActFolderId(docFolderId);
    },
    [docFolderId, act, setAct, actFolderId, setActFolderId]
  );

  React.useEffect(() => {
    if (act) {
      document.title = `Акт - ${act.Title}`;
    }
  }, [act]);

  return (<>
    {workflowInstance && act && (
      <div className="act-banner act-banner-info">
        Акт, направленный на согласование {constantFormat.DateTimeToString(workflowInstance.Created)}
      </div>
    )}
    {act && <>
      <div className="act-toolbar">
        <NewButton
          variant="secondary"
          icon={isDownloading ? `pi pi-spin pi-spinner` : `fa-solid fa-download`}
          disabled={!act?.Id || isDownloading}
          onClick={() => {
            const actId = act?.Id;
            if (actId) void downloadFile(`Acts/Export?id=${actId}`);
          }}>
          {isDownloading ? `Скачивание…` : `Скачать акт`}
        </NewButton>
      </div>
      <div className="document-editor-fill">
        <DocumentEditorComponent
          ref={editorRef}
          initialHtmlContent={act.HtmlTemplate || act.ActTemplate?.HtmlTemplate || ''}
          adminMode={false}
          readonly={true}
        />
      </div>
    </>}
    {actFolderId && !act && (
      <div className="act-banner act-banner-info">Нет предыдущих итераций</div>
    )}
  </>);
};


